// Maps the three pedals to their functionality, ordered: left, center, right
export var PedalOrder;
(function (PedalOrder) {
    PedalOrder["Rewind_Play_Forward"] = "Rewind_Play_Forward";
    PedalOrder["Forward_Play_Rewind"] = "Forward_Play_Rewind";
    PedalOrder["Rewind_Forward_Play"] = "Rewind_Forward_Play";
})(PedalOrder || (PedalOrder = {}));
